import { useRef } from 'react'

import Experience from '../../experience'
import GUI from './components/GUI'

import useScene from '../../config/hooks/useScene'

import { Container } from './styles'

const Scene = () => {
  const targetRef = useRef<HTMLDivElement>(null)
  let experience = useRef<Experience>()

  const { step, set } = useScene({ targetRef, experience })

  return (
    <>
      <GUI {...{ step, set, experience }} />
      <Container id="experience" ref={targetRef}></Container>
    </>
  )
}

export default Scene
